import SettingsView  from './components/SettingsView';


const Settings = () => {
  return (
      <SettingsView />
  )
}

export default Settings;

